import React from 'react';
import Carrusel from './CarruselCursos';
import cursos from './Cursos.json'; 


const Cursos = () => {
  return (
    <div id="cursos" className=" p-4 bg-purple-100 ">
      <h1 className="text-3xl font-bold text-center mb-8 text-[#37a7c1]">Empoderate</h1>
      <Carrusel cursos={cursos} />
    </div>
  );
};

export default Cursos;